import { render } from "./SessoesAdmin.vue?vue&type=template&id=bcb057b2"
import script from "./SessoesAdmin.vue?vue&type=script&lang=js"
export * from "./SessoesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__